import {
    INIT,
    IN_CURRENCY_SHOW_ACTION,
    OUT_CURRENCY_SHOW_ACTION,
    CLOSE_MODAL_ACTION,
    IN_CURRENCY_COIN,
    OUT_CURRENCY_COIN,
    NOT_ACTIVE_IN_CURRENCY_ACTION,
    NOT_ACTIVE_OUT_CURRENCY_ACTION,
    SEARCH_MODAL_IN_ACTION,
    SEARCH_MODAL_OUT_ACTION,
    IN_CURRENCY_ACTION,
    OUT_CURRENCY_ACTION,
    PAYWAY_ACTION,
    AMOUNT_ACTION,
    FAIL_PROVIDERS,
    NEXT_SCREEN,
    MIN_MAX_HALF_ACTION,
    LOADING_ACTION,
    LIMITS_ARRAY_ACTION,
    MODAL_ERROR_ACTION,
    RATE_PROVIDER_ACTION,
    PROVIDER_ACTION,
    CARD_DATA,
    CARD_COUNTRY_CODE,
    COUNTRY_SHOW,
    ONE_TIME_CARD,
    ADD_CARD,
    SEARCH_MODAL_COUNTRY_ACTION,
    NEED_VERIFICATION,
    SEARCH_MODAL_PAYWAY_ACTION,
    MOBILE_PHONE,
    ORDER_CREATED_ACTION,
    MODAL_SERVER,
    EMAIL_ACTION,
    ACCOUNT_NUMBER_ACTION,
    COUNTED_FEES,
    CHECKED_ALMOST_ALL,
    CREATED_ORDER_ERROR,
    EXPIRATED_RATE,
    POST_MESSAGE_ERROR
} from '../type'

const INITIAL_STATE = {
    sign: {},

    allExchangeWays: [],
    walletData: null,
    cashbackToken: null,
    payway: null,

    inCurrency: null,
    outCurrency: null,

    inAmount: null,
    amountValid: false,
    amountTimerId: null,
    amountHaveValid: false,
    minMaxLimits: {},
    outAmount: null,
    side: null,

    inCurrencyArray: [],
    inCurrencyNotActiveArray: [],
    outCurrencyArray: [],
    outCurrencyNotActiveArray: [],
    payways: [],
    notActivePayway: [],

    provider: null,
    providersArray: [],
    rateProvider: null,
    failProviders: false,

    outDestination: null,
    walletName: null,

    orderCreated: false,
    order: null,

    minMaxHalf: null,
    limitsTimerId: null,

    inCurrencyShow: false,
    outCurrencyShow: false,
    outPaywayShow: false,

    searchValueInCurrency: null,
    searchValueOutCurrency: null,
    searchValueCountry: null,
    searchValuePayway: null,

    version: null,

    modalError: false,

    cardData: {},
    cardCountryCode: null,
    countryShow: false,
    oneTimeCard: false,
    mobilePhone: null,

    needVerification: false,

    commnet: null,
    modalServer: false,
    maxLimit: false,

    countedFees: false,
    selectedFee: false,
    useAllFunds: false,
    loadAmount: false,

    checkedAlmostAll: null,
    originalData: {},

    textError: null,

    versionNumber: null,

    createdOrderError: false,
    expiratedRate: false,

    postMessageError: false

}

const MobileSellReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT:
            return {
                ...state,
                allExchangeWays: action.allExchangeWays,
                walletData: action.walletData,
                cashbackToken: action.cashbackToken,
                screen: action.screen,
                sign: action.sign,
                inCurrency: action.inCurrency,
                outCurrency: action.outCurrency,
                payway: action.payway,
                minMaxLimits: action.minMaxLimits,
                outDestination: action.outDestination,
                walletName: action.walletName,
                rateProvider: action.rateProvider,
                version: action.version,
                versionNumber: action.versionNumber
            }
        case IN_CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: action.inCurrency,
                inCurrencyShow: false,
                outDestination: action.outDestination,
                walletName: action.walletName,
                inAmount: null,
                outAmount: null,
                minMaxLimits: action.minMaxLimits
            }
        case NOT_ACTIVE_IN_CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: action.inCurrency,
                inCurrencyShow: false,
                outDestination: action.outDestination,
                walletName: action.walletName,
                inAmount: null,
                outAmount: null,
                outCurrency: null,
                payway: null,
                loading: false,
            }
        case OUT_CURRENCY_ACTION:
            return {
                ...state,
                outCurrency: action.outCurrency,
                payway: null,
                inAmount: null,
                outAmount: null
            }
        case NOT_ACTIVE_OUT_CURRENCY_ACTION:
            return {
                ...state,
                outCurrency: action.outCurrency,
                inCurrency: null,
                inAmount: null,
                outAmount: null,
                loading: false,
                payway: null
            }
        case IN_CURRENCY_SHOW_ACTION:
            return {
                ...state,
                inCurrencyShow: true,
                outCurrencyShow: false,
                outPaywayShow: 'CURRENCY'
            }
        case OUT_CURRENCY_SHOW_ACTION:
            return {
                ...state,
                outCurrencyShow: true,
                inCurrencyShow: false,
                outPaywayShow: action.outPaywayShow
            }
        case CLOSE_MODAL_ACTION:
            return {
                ...state,
                inCurrencyShow: false,
                outCurrencyShow: false
            }
        case IN_CURRENCY_COIN:
            return {
                ...state,
                inCurrencyArray: action.inCurrencyActive,
                inCurrencyNotActiveArray: action.inCurrencyNotActive
            }
        case OUT_CURRENCY_COIN:
            return {
                ...state,
                outCurrencyArray: action.outCurrencyActive,
                outCurrencyNotActiveArray: action.outCurrencyNotActive
            }
        case SEARCH_MODAL_IN_ACTION:
            return {
                ...state,
                searchValueInCurrency: action.searchValue
            }
        case SEARCH_MODAL_OUT_ACTION:
            return {
                ...state,
                searchValueOutCurrency: action.searchValue
            }
        case PAYWAY_ACTION:
            return {
                ...state,
                payway: action.payway,
                outCurrencyShow: false,
                cardData: {},
                mobilePhone: null,
                accountNumber: null,
                inAmount: null,
                outAmount: null,
                minMaxLimits: action.minMaxLimits,
            }
        case AMOUNT_ACTION:
            return {
                ...state,
                inAmount: action.amount,
                outAmount: action.equivalent,
                amountTimerId: action.timerId,
                providersArray: action.providersArray,
                amountValid: action.amountValid,
                amountHaveValid: action.amountHaveValid,
                loading: action.loading,
                maxLimit: action.maxLimit
            }
        case FAIL_PROVIDERS:
            return {
                ...state,
                failProviders: action.failProviders,
                rateProvider: state.rateProvider === null ? action.rateProvider : state.rateProvider
            }
        case NEXT_SCREEN:
            return {
                ...state,
                screen: action.screen
            }
        case MIN_MAX_HALF_ACTION:
            return {
                ...state,
                minMaxHalf: action.minMaxHalf,
                minMaxLimits: action.minMaxLimits,
                loading: true,
                failProviders: false,
            }
        case LOADING_ACTION:
            return {
                ...state,
                loading: action.loading
            }
        case LIMITS_ARRAY_ACTION:
            return {
                ...state,
                minMaxLimits: action.minMaxLimits,
                limitsTimerId: action.limitsTimerId
            }
        case MODAL_ERROR_ACTION:
            return {
                ...state,
                modalError: action.modalError,
                failProviders: action.failProviders,
                inCurrencyShow: false,
                outCurrencyShow: false,
                textError: action.textError
            }
        case RATE_PROVIDER_ACTION:
            return {
                ...state,
                rateProvider: action.rateProvider,
                minMaxLimits: action.minMaxLimits,
                minMaxHalf: null,
            }
        case PROVIDER_ACTION:
            return {
                ...state,
                provider: action.provider,
                rateProvider: action.rateProvider
            }
        case CARD_DATA:
            return {
                ...state,
                cardData: action.cardData
            }
        case CARD_COUNTRY_CODE:
            return {
                ...state,
                cardCountryCode: action.cardCountryCode,
                countryShow: false
            }
        case COUNTRY_SHOW:
            return {
                ...state,
                countryShow: action.countryShow
            }
        case ONE_TIME_CARD:
            return {
                ...state,
                oneTimeCard: action.oneTimeCard
            }
        case ADD_CARD:
            return {
                ...state,
                walletData: {
                    ...state.walletData,
                    cards: action.cards
                },
                oneTimeCard: false
            }
        case SEARCH_MODAL_COUNTRY_ACTION:
            return {
                ...state,
                searchValueCountry: action.searchValueCountry
            }
        case SEARCH_MODAL_PAYWAY_ACTION:
            return {
                ...state,
                searchValuePayway: action.searchValuePayway
            }
        case ORDER_CREATED_ACTION:
            return {
                ...state,
                orderCreated: !state.orderCreated,
            }
        case NEED_VERIFICATION:
            return {
                ...state,
                needVerification: action.needVerification
            }
        case MOBILE_PHONE:
            return {
                ...state,
                mobilePhone: action.mobilePhone
            }
        case MODAL_SERVER:
            return {
                ...state,
                modalServer: action.modalServer,
                textError: action.textError
            }
        case EMAIL_ACTION:
            return {
                ...state,
                email: action.email
            }
        case ACCOUNT_NUMBER_ACTION:
            return {
                ...state,
                accountNumber: action.accountNumber
            }
        case COUNTED_FEES:
            return {
                ...state,
                countedFees: action.countedFees,
                selectedFee: action.selectedFee,
                useAllFunds: action.useAllFunds,
                loadAmount: action.loadAmount
            }
        case CHECKED_ALMOST_ALL:
            return {
                ...state,
                checkedAlmostAll: action.checkedAlmostAll,
                originalData: action.originalData
            }
        case CREATED_ORDER_ERROR:
            return {
                ...state,
                createdOrderError: action.createdOrderError
            }
        case EXPIRATED_RATE:
            return {
                ...state,
                expiratedRate: action.expiratedRate
            }
        case POST_MESSAGE_ERROR:
            return {
                ...state,
                postMessageError: action.postMessageError
            }
        default:
            return {
                ...state
            }
    }
}

export default MobileSellReducer